import { useRef } from 'react';

export const useColorInput = () => {
  const ref = useRef<HTMLInputElement | null>(null);

  const onClick = () => {
    // force click action on the input to open color picker
    ref.current?.click();
  };

  return {
    inputRef: ref,
    childProps: {
      onClick,
    },
  };
};
